import { LoadableAfterPaint } from '@confluence/loadable';

export const PersonalizedTemplatesV2Loadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PersonalizedTemplatesV2" */ './PersonalizedTemplatesV2'
			)
		).PersonalizedTemplatesV2ErrorBoundary,
});
